import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Appfooter: React.FC = () => {
    
    const auth = useAuth();
    const user =
        (auth?.user as any) ||
        (typeof window !== 'undefined'
            ? JSON.parse(localStorage.getItem('user') || 'null')
            : null);
    const usuarioId = user?.id ?? '';
    const isAdmin = user?.role === 'ADMIN';

    
    var atletaId = (auth?.user as { atleta?: { id?: string } } | null)?.atleta?.id;
    return (
        <div className="app-footer border-0 shadow-lg bg-primary-gradiant">
            <Link to="/home" className="nav-content-bttn nav-center">
                <i className="bi bi-house"></i>
            </Link>
            <Link to={atletaId ? `/athlete/matches/${atletaId}` : '/defaultevent'} className="nav-content-bttn">
                <i className="bi bi-grid"></i>
            </Link>
            <Link to="/defaultevent" className="nav-content-bttn" data-tab="chats">
                <i className="bi bi-trophy"></i>
            </Link>
            <Link to={isAdmin ? "/admin/payments" : "/athlete/payments"} className="nav-content-bttn">
                <i className="bi bi-credit-card-2-front"></i>
            </Link>
            <Link to={ atletaId ? `/userpage/${atletaId}` : '/defaultsettings'} className="nav-content-bttn">
                <img
                    src={user?.imagemUrl ?? "assets/images/user.png"}
                    alt="user"
                    className="w30 shadow-xss rounded-pill"
                />
            </Link>
        </div>
    );
};

export default Appfooter;
